import { useState } from 'react';
import VoteCard from './voteCard';
import QrModal from './qrModal';
// import VoteCard,{voteExtToggle , setVoteExtToggle} from './voteCard';
import Vote  from './vote';
import Timer from '../features/timer';
import { useEffect } from 'react';

let events = require('../seeders/seedEvents.json');


let event = JSON.parse(window.localStorage.getItem('event'))
// let event_vote  = JSON.parse(window.localStorage.getItem('event_vote'))

function getCardInfo(){
    const PORT=3000
    const MONGO_URI="mongodb://localhost:27017/votes"
 }
 function generateVotes(view){
   let vote_map = event.event_votes.map((vote,index) => {
      return (<VoteCard vote={vote} key={index} view ={view} />)
   })
   return vote_map   
}
function Event(props) {
     let cur_user = props.cur_user
     const [ showQr , setShowQr ] = useState(false)
     const [ qrPos , setQrPos ] = useState('qr-event-down')
    // try{ cur_user = JSON.parse(window.localStorage.getItem('cur_user'))}
    // catch(err){
    //     // document.getElementById("demo").innerHTML = err.message
    //     console.log(err.message)
    //     cur_user= '
    // }
    let event =  events[props?.event_id]
   const {event_id,event_title,event_type,event_host_name,event_time_handling,event_link,material_links,event_creator,event_admin,event_attendees,event_descr,event_votes,event_status,event_end}  =  event
   const view = props.view
    console.log("events :",events)
   let time_class = `${event_time_handling.type} blink-slower`
   const [showAdmin , setShowAdmin] = useState(false)
   const [showDuration , setShowDuration] = useState(false)
   const [time, setTimer] = useState('')
   const mm_btn_opn = 'frame-mm-button show-box blink'
   const mm_btn_cls = 'frame-mm-button-close show-box blink'
   const [mtgVtPos, setMtgVtPos] = useState('slide-up')
   const [mtgVtBox, setMtgVtBox] = useState(false)
   const [vidLinkMod, setVidLinkMod] = useState('')
   let vc_vt_toggle
    // const launch_date = `2023-03-01T08:00:00Z`
   //  let [time, setTimer] = useState()
    let status_class =`${event_status} blink`

    
    function timer(){
      var countDownDate = new Date(event_end).getTime();
      // Update the count down every 1 second
      var x = setInterval(function() {
      // Get today's date and time
      var now = new Date().getTime();
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // Display the result in the element with id="demo"
      setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`)
      // If the count down is finished, write some text
      if (distance < 0) {
          clearInterval(x);
          setTimer(`expired`)
      }
      }, 1000);
          }
          function toggleQR(){   
            if(!showQr){
              setShowQr(true)
              setQrPos('qr-event-up')
              }else{
                  setQrPos('qr-event-down')
                setShowQr(false)
                  }
                console.log("toggleEventVid click")
              }
function toggleVtBox(elem){
   if((!mtgVtBox)){
      setMtgVtPos('slide-up')
      setMtgVtBox(true)

      window.localStorage.setItem('voteToggle',true)
      }else{
      setMtgVtPos('slide-down')
      setMtgVtBox(false)
      window.localStorage.setItem('voteToggle',false)
    
      }
      console.log("toggleMtgVt click")
}

   // useEffect(()=>{
   //   vc_vt_toggle = JSON.parse(window.localStorage.getItem('voteToggle'))
   //    setMtgVtBox(JSON.parse(window.localStorage.getItem('voteToggle')))
   //  if(!mtgVtBox){
   //      toggleVtBox()
   //      console.log("[Meeting]  mtgVtBox:", mtgVtBox)
   //   }
   //   else if(vc_vt_toggle === "close"){
   //      toggleVtBox()
   //   }

   // },[])

    if (showDuration){timer()}
   //  let vidLinkClass = `vid-link ${vidLinkMod} blink-faster`
    let qrLinkClass = `blink-faster`
   let mtg_vt_cls_ButtonClass = `vd-mt-vt-button show-box blink`
   console.log("Event (events[0]) :",events[0])
    return (
        <div className="event-container ">   
        <div className = {`qr-wrap ${qrPos}`} id="event-qr">
                       <div id="qr-modal-close" onClick={toggleQR}>close</div>
                        <QrModal user={props.user} tag={event_title} view={props.view}/>
                    </div>
            <div className={qrLinkClass} id="event-qr-link" onClick={toggleQR}>     
                <img src="/images/qrcode.svg" alt='qr code icon'/>
            </div>

        <div className="meeting-header">
         <div className={status_class} id ="meeting-status">
            &#x2022;   {event_status}
         </div>
         <div className="meeting-comp-top-right" id="meeting-type">
            <span className={event_type}>{event_type}</span>
         </div>
       
           
            <h2 className="view-header blink-slower" id="view-header">"{event_title}"</h2>
            
            {/* <h4 className="color-grad-blue-text">"{meeting_title}"</h4> */}
            <span className="meeting_time_handling">
                       {!showDuration&&(
                        <span className={time_class} id="meeting_time_handling" 
                            onClick={() => 
                            setShowDuration(true)}>
                            &#9663; {event_time_handling.type}-time 
                        </span> )}
                        {showDuration&&( 
                            <span className= {time_class} id="meeting_time_handling"
                            onClick={() => setShowDuration(false)}
                            >&#9657; {time}</span>)} 
                    </span> 
                    <div className = "meeting-attendees" id="meeting-attendees">
                            attendees: &nbsp; {event_attendees.length}
                    </div>
            
            <span>
                       {!showAdmin&&(
                        <span id="admin-tag"  className='blink' 
                            onClick={() => setShowAdmin(true)}>
                            admin &#9663;
                        </span> )}
                        {showAdmin&&( <span className="admin_info blink"
                        onClick={() => setShowAdmin(false)}
                        >{event_admin}&#9667;</span>)} 
                    </span>
                    </div>
            <div id='meeting-content-wrap'>
               <div className='meeting-content'>
                  {/* {generateVotes(view)} */}

                        filler feed content

               </div>
            </div>

    
        </div>
  );
}
export default Event; 